// src/state/editAggregateStore.js
// Stores aggregated features per editId (palette + garmentCounts + updatedAt + sourceHash)

const KEY = (editId) => `veya_edit_agg_v1::${editId}`;

function safeJsonParse(raw, fallback) {
  try {
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function safeRead(editId) {
  if (!editId) return null;
  const raw = localStorage.getItem(KEY(editId));
  const obj = safeJsonParse(raw, null);
  return obj && typeof obj === "object" ? obj : null;
}

function safeWrite(editId, obj) {
  if (!editId) return;
  try {
    localStorage.setItem(KEY(editId), JSON.stringify(obj || null));
  } catch {}
}

function hashString(str) {
  const s = String(str || "");
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16);
}

// Build an edit-level hash from eligible pins (image+note) + their content hash.
// This changes when pins are added/removed OR when their imageUrl/text changes.
export function computeEditAggregateHash(pins, computePinSourceHash) {
  const list = (pins || [])
    .filter((p) => {
      const k = String(p?.kind || "").toLowerCase();
      return k === "image" || k === "note";
    })
    .map((p) => `${p.id}:${computePinSourceHash(p) || ""}`)
    .sort()
    .join("|");

  return hashString(list);
}

export function getEditAggregate(editId) {
  return safeRead(editId);
}

export function setEditAggregate(editId, agg) {
  const cur = safeRead(editId) || {};
  const next = { ...cur, ...agg, updatedAt: Date.now() };
  safeWrite(editId, next);
  return next;
}

export function clearEditAggregate(editId) {
  safeWrite(editId, null);
}